<template>

  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <!-- Search Bar -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Хэрэглэгчдийн жагсаалт</h1>
        <div class="w-25">
          <input type="text" v-model="searchQuery" class="form-control" placeholder="Нэр эсвэл имэйлээр хайх..." />
        </div>
      </div>

      <table class="table" v-if="filteredUsers.length">
        <thead>
          <tr>
            <th>
              <button class="btn btn-link" @click="toggleSort">
                ID
                <i :class="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
              </button>
            </th>
            <th>Хэрэглэгчийн мэдээлэл</th>
            <th>Төлөв</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in filteredUsers" :key="user.id">
            <td>{{ user.id }}</td>
            <td class="text-center" style="display: flex; flex-direction: column">
              <h4 class="display-4 mb-0" style="text-align: left">
                {{ user.lastname }} {{ user.firstname }} 
              </h4>
              <span class="description" style="text-align: left">
                {{ user.email }} | {{ getUserType(user.user_type) }}
              </span>
            </td>
            <td>
              <span :style="{
                        backgroundColor: user.is_active ? '#d1fae5' : '#e5e7eb',
                        color: user.is_active ? '#065f46' : '#4b5563',
                        padding: '4px 12px',
                        borderRadius: '9999px',
                        fontWeight: '500',
                        fontSize: '14px',
                        display: 'inline-block'
                      }" > {{ user.is_active ? "Идэвхтэй" : "Идэвхгүй" }} </span>
            </td>
            <td class="td-actions text-right">
              <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title="" title=""
                @click="openEditModal(user)">
                <i class="fa fa-pencil pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="text-center py-4">
        <p class="h4 text-muted">Таны хайлтанд тохирох хэрэглэгч олдсонгүй.</p>
      </div>
    </div>
    <!-- User Edit Modal -->
    <Modal :show.sync="showModal" class="modalOverlay">
      <div class="modal-header">
        <h3>Хэрэглэгчийн мэдээлэлийг засах</h3>
      </div>

      <form @submit.prevent="handleSubmit" class="modalForm">
        <div class="form-group">
          <label>Нэр</label>
          <input v-model="userData.firstname" class="form-control" type="text" required />
        </div>

        <div class="form-group">
          <label>Овог нэр</label>
          <input v-model="userData.lastname" class="form-control" type="text" required />
        </div>

        <div class="form-group">
          <label>Имэйл</label>
          <input v-model="userData.email" class="form-control" type="email" required />
        </div>

        <div class="form-group">
          <label>Утас</label>
          <input v-model="userData.phone" class="form-control" type="tel" required />
        </div>

        <div class="form-group">
          <label>Төрөл</label>
          <select v-model="userData.user_type" class="form-control">
            <option value="1">Сурагч</option>
            <option value="2">Багш</option>
          </select>
        </div>

        <div class="form-group">
          <label>Status</label>
          <div class="toggle">
            <input type="checkbox" v-model="userData.is_active" :id="'status-toggle'" />
            <label :for="'status-toggle'">{{
              userData.is_active ? "Active" : "Inactive"
            }}</label>
          </div>
        </div>

        <div class="modal-footer">
          <base-button type="link" class="cancelButton" @click="closeModal">
          буцах
          </base-button>
          <base-button @click="handleSubmit" type="primary" class="saveButton">хадгалах</base-button>
        </div>
      </form>
    </Modal>
  </card>


</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";

export default {
  name: "UserList",
  data() {
    return {
      userList: [],
      userData: {
        email: "",
        lastname: "",
        firstname: "",
        phone: "",
        user_type: 1,
        is_active: true,
      },
      showModal: false,
      searchQuery: "",
      sortDirection: "asc"
    };
  },
  created() {
    this.fetchUserList();
  },
  components: {
    Modal,
  },
  computed: {
    filteredUsers() {
      let users = [...this.userList];

      // Apply search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        users = users.filter(user =>
          user.email.toLowerCase().includes(query) ||
          `${user.firstname} ${user.lastname}`.toLowerCase().includes(query)
        );
      }

      // Apply sorting
      users.sort((a, b) => {
        if (this.sortDirection === 'asc') {
          return a.id - b.id;
        } else {
          return b.id - a.id;
        }
      });

      return users;
    }
  },
  methods: {
    fetchUserList() {
      axios
        .get("/users")
        .then((response) => {
          this.userList = response.data;
        })
        .catch((error) => {
          console.error("Error fetching user list:", error);
        });
    },

    toggleSort() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    },

    getUserType(type) {
      const types = {
        1: "Student",
        2: "Teacher",
      };
      return types[type] || "Unknown";
    },

    openEditModal(user) {
      this.userData = { ...user };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.userData = {
        email: "",
        lastname: "",
        firstname: "",
        phone: "",
        user_type: 1,
        is_active: true,
      };
    },

    handleSubmit() {
      if (this.userData.id) {
        axios
          .put(`/user/${this.userData.id}`, this.userData)
          .then(() => {
            this.fetchUserList();
            this.closeModal();
          })
          .catch((error) => {
            console.error("Submission error:", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
  color: inherit;
}
</style>